var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nameFiled in _vm.configData)?_c('fg-input',{attrs:{"label":_vm.nameFiled,"disabled":_vm.disabled,"name":_vm.nameFiled,"data-cy":_vm.nameFiled},model:{value:(_vm.configData[_vm.nameFiled]),callback:function ($$v) {_vm.$set(_vm.configData, _vm.nameFiled, $$v)},expression:"configData[nameFiled]"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }